/**
 * An object containing properties for a sortable field, used to select categories of sorting
 */
var SortField = /** @class */ (function () {
    function SortField() {
    }
    return SortField;
}());
export { SortField };
//# sourceMappingURL=sort-field.js.map